import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  dateDefault,
  formLabelsTheme,
  getValueType,
  iconError,
  optionsStatus,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  validateDateFields,
  validatePost,
} from "../../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import {
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchReporting,
  selectReporting,
  fetchFile,
  fetchFileBlob,
  fetchReportingVehicleInfo,
  fetchReportingVehicleInfoDownload,
  fetchReportingVehicleInfoDownloadBlob,
  selectReporting2,
} from "../reportingSlice";
import { ReportTable } from "./ReportTable";

import { useStyles, useStylesReddit } from "../../../utility";

import { ModalColorRadio } from "../../modalfilter/ModalColorRadio";
import { ModalProductRadio } from "../../modalfilter/ModalProductRadio";
import { ModalModelRadio } from "../../modalfilter/ModalModelRadio";
import { ModalClientRadio } from "../ModalClientRadio";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../../businessParameter/businessParameterSlice";
import { Autocomplete } from "@material-ui/lab";
import { FormHelperText } from "@material-ui/core";
import { ModalPartiesRadio } from "../ModalPartiesRadio";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ReportVehicleInfoPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectReporting2);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);

  const [btnHideFilter, setBtnHideFilter] = useState(false);

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  // Fungsi untuk mengubah nilai btnHide antara true dan false
  const toggleBtnHideFilter = () => {
    setBtnHideFilter(!btnHideFilter);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "SERVICE_CLASS",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "JOB_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    receive_date_start: {
      value: "",
      error: false,
      required: "N",
    },
    receive_date_end: {
      value: "",
      error: false,
      required: "N",
    },
    vehicle_status: {
      value: [],
      error: false,
      required: "N",
    },
  });

  const handleSearch = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const dateFields = ["receive_date"];

    const dateValidationResult = validateDateFields(formValues, dateFields);
    if (dateValidationResult) {
      return showErrorDialog(dateValidationResult);
    }
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      Client: formValues.client_name.value,
      // reportType: "Vehicle_Information",
      start_Receive_Date: formValues.receive_date_start.value,
      end_Receive_Date: formValues.receive_date_end.value,
      Vehicle_Status: formValues.vehicle_status.value.join(','),
    };

    try {
      const response = await dispatch(fetchReportingVehicleInfo(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        Client: formValues.client_name.value,
        pageNo: page,
        pageSize: sizePerPage,
        // reportType: "Vehicle_Information",
        start_Receive_Date: formValues.receive_date_start.value,
        end_Receive_Date: formValues.receive_date_end.value,
        Vehicle_Status: formValues.vehicle_status.value.join(','),
      };

      try {
        const response = await dispatch(fetchReportingVehicleInfo(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleDownload = async () => {
    const dateFields = ["receive_date"];

    const dateValidationResult = validateDateFields(formValues, dateFields);
    if (dateValidationResult) {
      return showErrorDialog(dateValidationResult);
    }
    let params = {
      // reportType: "Vehicle_Information",
      Client: formValues.client_name.value,
      start_Receive_Date: formValues.receive_date_start.value,
      end_Receive_Date: formValues.receive_date_end.value,
      Vehicle_Status: formValues.vehicle_status.value.join(','),
    };

    try {
      const response = await dispatch(
        fetchReportingVehicleInfoDownload(params)
      );
      if (response.payload.status === 200) {
        showSuccessDialog(response.payload.data.message);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // Parameter

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "vin",
      label: "VIN",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VON",
      show: "Y",
      editor: "text",
    },

    {
      id: "4",
      value: "Master_Code",
      label: "Master Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Vehicle_Name",
      label: "Vehicle Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Model_Code",
      label: "Model Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Model_Name",
      label: "Model Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Color_Code",
      label: "Color Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Color_Name",
      label: "Color Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "Key_No",
      label: "Key No.",
      show: "Y",
      editor: "text",
    },

    {
      id: "4",
      value: "Booking_Status",
      label: "Status",
      show: "Y",
      editor: "status",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah

  // modal filter
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showProduct, setShowProduct] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [showParty, setShowParty] = useState(false);
  const [getData, setGetData] = useState(false);
  const [getDataClient, setGetDataClient] = useState(false);
  const [getDataDealer, setGetDataDealer] = useState(false);

  const [partyType, setPartyType] = useState(false);

  const handleSelectChange = (i, e) => {
    if (e === null) {
      e = undefined;
      const values = [...fields];
      values[i].value = "";
      setFields(values);
    } else {
      const values = [...fields];
      values[i].value = e.value;

      setFields(values);
    }
  };

  const [fieldsFilter, setFieldsFilter] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const optionsStatusVehicle = [
    { label: "Ready For RCI", value: "070" },
    { label: "RCI OK", value: "150" },
    { label: "RCI NG", value: "117" },
    { label: "PDI-In OK", value: "160" },
    { label: "PDI-Out NG", value: "185" },
    { label: "PDI-Out OK", value: "190" },
    { label: "Storage OK, RFS OK", value: "480" },
    { label: "Booking Confirmed", value: "490" },
    { label: "Picking Confirmed", value: "710" },
    { label: "Handover Confirmed, MP-OUT", value: "760" },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={toggleBtnHideFilter}
            >
              <span
                className="svg-icon svg-icon-md svg-icon-light"
                style={{ marginRight: "0px" }}
              >
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/New/SearchParameter.svg"
                  )}
                  className="mr-2"
                />
              </span>
              Search Parameter
            </Button>
            {btnHideFilter === true && (
              <>
                <div className="mb-5">
                  <ThemeProvider theme={formLabelsTheme}>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              required
                              label="Client"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.client_name.value}
                              readOnly
                              error={formValues.client_name.error}
                              helperText={
                                formValues.client_name.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className="display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setShowClient(true);
                                    setGetDataClient(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.client_name.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,

                                    ["client_name"]: {
                                      ...formValues["client_name"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="Date From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="receive_date_start"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.receive_date_start.value}
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <p className="text-center mt-5">To</p>
                          </Col>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="Date Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="receive_date_end"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.receive_date_end.value}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              options={optionsStatusVehicle}
                              getOptionLabel={(option) => `${option.label} (${option.value})`}
                              getOptionValue={(option) => option.value}
                              value={
                                optionsStatusVehicle.filter(
                                  (option) =>
                                    formValues.vehicle_status.value !== null && formValues.vehicle_status.value.includes(option.value)
                                ) || []
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null || newValue.length === 0) {
                                  setFormValues({
                                    ...formValues,
                                    ["vehicle_status"]: {
                                      ...formValues["vehicle_status"],
                                      value: [],
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["vehicle_status"]: {
                                      ...formValues["vehicle_status"],
                                      value: newValue.map(it => it.value),
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Vehicle Status"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="vehicle_status"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </ThemeProvider>
                </div>

                <Row className="mt-6 justify-content-end">
                  <Button className="mr-3" onClick={handleDownload}>
                    <span
                      className="svg-icon svg-icon-md svg-icon-light"
                      style={{ marginRight: "0px" }}
                    >
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/XLS.svg")}
                      />
                    </span>
                    Download
                  </Button>

                  <Button
                    className="mr-3 btn-filter"
                    variant="primary"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Row>
              </>
            )}

            <ReportTable
              data={data === null ? [] : data}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
            />
          </CardBody>
        </Card>
      </div>

      <ModalClientRadio
        isOpen={showClient}
        setShow={setShowClient}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataClient}
        setGetData={setGetDataClient}
      />

      <ModalModelRadio
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />
      <ModalProductRadio
        isOpen={showProduct}
        setShow={setShowProduct}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />
      <ModalColorRadio
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />

      <ModalPartiesRadio
        isOpen={showParty}
        setShow={setShowParty}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFields}
        fields={fields}
        getData={getDataDealer}
        setGetData={setGetDataDealer}
        partyType={partyType}
        setPartyType={setPartyType}
      />
    </>
  );
};
